import { IDeviceSize } from '@checkout/device';
import { RootState } from '@checkout/state';
import { Field } from 'formik';
import { ChangeEvent } from 'react';
import * as React from 'react';
import { Fragment } from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { ICheckoutContextConfig } from '../../../config/contextCheckoutConfig.d';
import messages from '../../../i18n/base-en';
import { updateNewsletterFieldRequest } from '../../../reducers/checkout';
import { InputBox, InputBoxField, TermsLink } from './../../presentational';

interface IOwnProps {
  id: string;
  name: string;
  checkoutContextConfig: ICheckoutContextConfig;
  reverse?: boolean;
  sendNewsletterValue?: boolean;
  deviceSize?: IDeviceSize;
}

interface IConnectedProps {
  newsletter: boolean;
}

interface IConnectetDispatchProps {
  updateNewsletterFieldRequest: typeof updateNewsletterFieldRequest;
}

interface IOwnState {
  checked: boolean;
}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

class NewsletterCheckbox extends React.Component<Props, IOwnState> {

  state: IOwnState = {
    checked: this.props.newsletter,
  };

  handleChange = (event: ChangeEvent<any>) => {
    const checked = !this.props.newsletter;

    this.setState({
      checked
    });

    if (this.props.sendNewsletterValue) {
      this.props.updateNewsletterFieldRequest({ address: { newsletter: checked } });
    }
  }

  render() {
    const { checked } = this.state;
    const { id, name, intl, checkoutContextConfig, reverse, sendNewsletterValue, deviceSize } = this.props;
    const { formatMessage } = intl;

    const renderTermsLabel = (url: string, isTermsLinkVisible: boolean) => (
      <Fragment>
        {formatMessage(messages.newsletter_checkbox_label)}
        {isTermsLinkVisible && (
          <TermsLink
            variant={deviceSize && deviceSize.md ? 'block' : 'inline'}
            label={`${formatMessage(messages.newsletter_checkbox_link_label)}`}
            url={url}
          />
        )}
      </Fragment>
    );

    return (
      <Fragment>
        {!sendNewsletterValue && (
          <Field
            id={id}
            name={name}
            component={InputBoxField}
            semanticType="checkbox"
            reverse={reverse}
            value={checked}
            checked={checked}
            onChange={this.handleChange}
            label={renderTermsLabel(checkoutContextConfig.ui.consentGroup.newsletterTermsLink.url,
              checkoutContextConfig.ui.consentGroup.newsletterTermsLink.isTermsLinkVisible)}
          />
        )}
        {sendNewsletterValue && (
          <InputBox
            id={id}
            name={name}
            type="checkbox"
            reverse={reverse}
            value={checked}
            checked={checked}
            onChange={this.handleChange}
            label={renderTermsLabel(checkoutContextConfig.ui.consentGroup.newsletterTermsLink.url,
              checkoutContextConfig.ui.consentGroup.newsletterTermsLink.isTermsLinkVisible)}
          />
        )}
      </Fragment>
    );
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps,  IConnectetDispatchProps>(
    (state: RootState) => ({
      newsletter: state.checkout.cartFieldsData.newsletter
    }),
    {
      updateNewsletterFieldRequest,
    }
  ),
)(NewsletterCheckbox);
